/* Source: /home/sidsolaiyappan/skooch_ai/shared/auth_token.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { get_supabase } from "./supabase_config.js";
function extractAccessToken(result) {
  if ((((result && result.data) && result.data.session) && result.data.session.access_token)) {
    return result.data.session.access_token;
  }
  return "";
}
async function getAccessToken() {
  let _sb = get_supabase();
  let result = await _sb.auth.getSession();
  return extractAccessToken(result);
}
export {extractAccessToken, getAccessToken};
//# sourceMappingURL=auth_token.js.map
